import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    show: async ({ missionId, mission_user_list_id, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists/" + mission_user_list_id;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    show_user: async ({ missionId, mission_user_list_id, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists/" + mission_user_list_id + "/show_user";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    show_screener_response: async ({ missionId, mission_user_list_id, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists/" + mission_user_list_id + "/show_screener_response";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    review_users: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists/review_users";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    approve_user: async ({ missionId, missionUserListId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists/" + missionUserListId + "/approve_user";

        const body = JSON.stringify({
            mission_user_list_id: missionUserListId
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    reject_user: async ({ missionId, missionUserListId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_user_lists/" + missionUserListId + "/reject_user";

        const body = JSON.stringify({
            mission_user_list_id: missionUserListId
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }
}